// extracted by mini-css-extract-plugin
module.exports = {"appsList":"SummaryApps_appsList__BP9tu"};